import { get } from 'svelte/store';
import { page } from '$app/stores';

export function appUserLink(link) {
	const pageUrl = get(page).url;
	const url = new URL(link, pageUrl.origin);

	const debtor = pageUrl.searchParams.get('d');
	if (debtor) url.searchParams.set('d', debtor);

	if (typeof link === 'string' && link.startsWith('/')) {
		return url.pathname + url.hash + url.search;
	}

	return url.href;
}
